import React, { useRef, useEffect, useState } from "react";
import * as tf from "@tensorflow/tfjs";

const SnapDetector = () => {
  const [model, setModel] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const loadModel = async () => {
      // We'll use a standard Segmentation architecture
      const m = tf.sequential();
      m.add(
        tf.layers.conv2d({
          inputShape: [256, 256, 3],
          kernelSize: 3,
          filters: 16,
          activation: "relu",
          padding: "same",
        })
      );
      m.add(
        tf.layers.conv2d({
          kernelSize: 1,
          filters: 1,
          activation: "sigmoid",
          padding: "same",
        })
      );
      setModel(m);
    };
    loadModel();
  }, []);

  const handleUpload = (e) => {
    if (e.target.files[0]) setImageURL(URL.createObjectURL(e.target.files[0]));
  };
  const processAndSave = async () => {
    if (!imageRef.current) return;

    const img = imageRef.current;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;

    // 1. Get the Image Data
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    // 2. SEARCH FOR THE DOOR (The "Snap" Logic)
    // Instead of a weak model, let's look for the highest contrast
    // areas that AREN'T the edge of the photo.

    let minX = canvas.width,
      maxX = 0,
      minY = canvas.height,
      maxY = 0;
    let found = false;

    // We scan the image in a grid
    for (let y = canvas.height * 0.1; y < canvas.height * 0.9; y += 10) {
      for (let x = canvas.width * 0.1; x < canvas.width * 0.9; x += 10) {
        // Look for the "Blue" of the door or the "Dark" of the frame shadow
        const index = (Math.floor(y) * canvas.width + Math.floor(x)) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];

        // DETECTION RULE: If pixel is "Door-ish" (Blue-ish or distinct from white wall)
        if (b > r + 20 && b > g + 20) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
          found = true;
        }
      }
    }

    // 3. DRAW THE SNAPPED FRAME
    if (found) {
      ctx.strokeStyle = "#3400ff";
      ctx.lineWidth = 15;

      // The "U" Shape Snap
      ctx.beginPath();
      ctx.moveTo(minX, maxY); // Bottom Left
      ctx.lineTo(minX, minY); // Top Left
      ctx.lineTo(maxX, minY); // Top Right
      ctx.lineTo(maxX, maxY); // Bottom Right
      ctx.stroke();
    }

    // 4. SAVE
    const link = document.createElement("a");
    link.download = "snapped_door.png";
    link.href = canvas.toDataURL();
    link.click();
  };

  return (
    <div style={{ padding: "20px" }}>
      <input type="file" onChange={handleUpload} />
      {imageURL && (
        <>
          <img
            ref={imageRef}
            src={imageURL}
            style={{ display: "block", width: "400px", marginTop: "10px" }}
          />
          <button onClick={processAndSave} style={{ marginTop: "10px" }}>
            Detect and Save Image
          </button>
        </>
      )}
    </div>
  );
};

export default SnapDetector;
